
import { environment } from '../../environments/environment';

// i18n / translations
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient} from '@angular/common/http';


// i18n / translation: required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {

  //if localhost or under proper domain, don't add prefix for loading language file. if hosted, add the URL prefix to the file path !
  if (environment.urlSuffix) {
    console.devlog("i18n suffix is:", environment.urlSuffix)
    return new TranslateHttpLoader(http, environment.urlSuffix);
  } else {
    // testing locally !
    return new TranslateHttpLoader(http);
  }
}